import { defineMessages } from "react-intl";

export default defineMessages({
  caption: {
    id: "durationInput.caption",
    defaultMessage: "HH : MM",
  },
  decrease: {
    id: "durationInput.decrease",
    defaultMessage: "Diminuer",
  },
  increase: {
    id: "durationInput.increase",
    defaultMessage: "Augmenter",
  },
});
